<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form @submit.prevent="handleSubmit">
        <div class="flex -mx-2 mb-5">
          <div class="flex-1 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.contractInformation')" collapse-action>
              <div class="vx-row mb-5 flex">
                <div class="vx-col w-1/4">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractDate')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractDate') }}</label>
                    <flat-pickr :config="config" class="w-full" v-model="form.contractDate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-5/12">
                  <validation-provider :name="$t('sections.accounting.dataForm.borrower')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.borrower') }} <small class="ml-2"
                                                                                                            v-if="totalMatched > maxOptions">
                      #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalMatched }} รายการที่พบ
                    </small></label>

                    <v-select
                      v-model="form.borrower"
                      :filterable="false"
                      :options="filteredBorrowers"
                      :clearable="true"
                      @search="onSearchBorrower"
                      label="label"
                    >
                    </v-select>

                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractNo')" rules="required|length:15"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t("sections.accounting.dataForm.contractNo") }}</label>
                    <vs-input type="text" class="w-full" v-model="form.contractNo" disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractIndex')"
                                       rules="required|contractIndexFormat" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractIndex') }}</label>
                    <vs-input type="text" class="w-full" v-model="form.contractIndex"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5 flex">
                <div class="vx-col w-1/4">
                  <validation-provider :name="$t('sections.accounting.dataForm.project')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.project') }}</label>
                    <v-select v-model="form.project" :clearable="false" :options="projectOptions"
                              :name="$t('sections.accounting.dataForm.project')" :reduce="res => res.value"
                              :disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-5/12">
                  <validation-provider :name="$t('sections.accounting.dataForm.campus')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.campus') }}</label>
                    <v-select v-model="form.campus" :clearable="false" :options="filteredCampusOptions"
                              :name="$t('sections.accounting.dataForm.project')" :reduce="res => res.value"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.periods.begin')" rules="required"
                                       v-slot="{ errors }">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.periods.begin')"
                                           rules="required|periodTermYear" v-slot="{ errors }">
                        <label class="vs-input--label">ปีการศึกษาที่เริ่มกู้*</label>
                        <vs-input type="text" v-model="form.periodStart" class="w-full"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.periods.end')" rules="required"
                                       v-slot="{ errors }">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.periods.end')"
                                           rules="required|periodTermYear" v-slot="{ errors }">
                        <label class="vs-input--label">ปีการศึกาษาสุดท้าย*</label>
                        <vs-input type="text" v-model="form.periodEnd" class="w-full"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5">
                <div class="vx-col w-2/3">
                  <validation-provider :name="$t('sections.accounting.dataForm.curriculum')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.curriculum') }}</label>
                    <v-select v-model="form.curriculum" :clearable="false" :options="facultyCurriculumOptions"
                              :name="$t('sections.accounting.dataForm.curriculum')" :reduce="res => res.value"
                              :disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.forecastDate')" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.forecastDate') }}</label>
                    <flat-pickr :config="config" class="w-full" v-model="form.forecastDate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.graduationDate')" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.graduationDate') }}</label>
                    <flat-pickr :config="config" class="w-full" v-model="form.graduationDate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5">
                <div class="vx-col w-1/4">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractAmount')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractAmount') }}</label>
                    <vs-input type="number" class="w-full" v-model="form.contractAmount"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-5/12">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractAmountText')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractAmountText') }}</label>
                    <vs-input type="text" class="w-full" v-model="form.contractAmountText" disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.period')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.period') }}</label>
                    <vs-input type="number" class="w-full" v-model="form.loan.period"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.paymentDue')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.paymentDue') }}</label>
                    <flat-pickr :config="configPaymentDue" class="w-full" v-model="form.loan.paymentDue"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5 flex">
                <div class="vx-col w-2/3">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.loanType')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.loanType') }}</label>
                    <v-select v-model="form.loan.loanType" :clearable="false" :options="loanTypesOptions"
                              :name="$t('sections.accounting.dataForm.loan.loanType')" :reduce="res => res.value"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.paymentDescription')" rules=""
                                       v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.paymentDescription') }}</label>
                    <vs-textarea v-model="form.loan.paymentDescription" rows="6" class="mt-2"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/3">
                  <div class="vx-row">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.interestRate')" rules="required"
                                           v-slot="{ errors }">
                        <label
                          class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.interestRate') }}</label>
                        <vs-input type="number" class="w-full" v-model="form.loan.interestRate"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.interestType')" rules="required"
                                           v-slot="{ errors }">
                        <label
                          class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.interestType') }}</label>
                        <vs-select v-model="form.loan.interestType" class="w-full" :disabled="isExternalUser">
                          <vs-select-item :key="index" :value="item.value" :text="item.label"
                                          v-for="(item,index) in interestTypesOptions" class="w-full"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.penaltyRate')" rules="required"
                                           v-slot="{ errors }">
                        <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.penaltyRate') }}</label>
                        <vs-input type="number" class="w-full" v-model="form.loan.penaltyRate"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.penaltyType')" rules="required"
                                           v-slot="{ errors }">
                        <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.penaltyType') }}</label>
                        <vs-select v-model="form.loan.penaltyType" class="w-full" :disabled="isExternalUser">
                          <vs-select-item :key="index" :value="item.value" :text="item.label"
                                          v-for="(item,index) in interestTypesOptions" class="w-full"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col flex-1">
                      <validation-provider name="ค่าธรรมเนียมการทวงถาม" rules="required" v-slot="{ errors }">
                        <label class="vs-input--label">ค่าธรรมเนียมการทวงถาม</label>
                        <vs-input type="text" class="w-full" v-model="form.loan.debtCollectionFeeAmount"
                                  disabled="disabled"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="vx-col flex-1">
                      <validation-provider name="การคิดค่าธรรมเนียมการทวงถาม" rules="required" v-slot="{ errors }">
                        <label class="vs-input--label">การคิดค่าธรรมเนียมการทวงถาม</label>
                        <vs-select v-model="form.loan.debtCollectionFeeType" class="w-full" :disabled="isExternalUser">
                          <vs-select-item :key="index" :value="item.value" :text="item.label"
                                          v-for="(item,index) in debtCollectionFeeTypesOptions" class="w-full"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="flex -mx-2 mb-5">
          <div class="flex-1 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.suretyInformation')" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="suretyDetails">
                    <template slot="thead">
                      <vs-th class="w-1/6">ลำดับ</vs-th>
                      <vs-th>ชื่อนามสกุล</vs-th>
                      <vs-th>เกี๋ยวข้องเป็น</vs-th>
                      <vs-th class="w-1/6"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(row, index) in data">
                        <vs-td :data="(index+1)">
                          {{ (index + 1) }}
                        </vs-td>
                        <vs-td>
                          {{ suretyName(row.surety.id) }}
                        </vs-td>
                        <vs-td>
                          <vs-select v-model="row.relationship" class="w-full ">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in relationshipOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete"
                                     @click="delSureties(index)"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus-square"
                             @click="addSureties()"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="flex-1 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.paymentRoundInformation')" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="paymentRounds">

                    <template slot="thead">
                      <vs-th class="w-1/12">{{ $t('sections.accounting.dataForm.tablePaymentRound.no') }}</vs-th>
                      <vs-th class="w-1/6">{{ $t('sections.accounting.dataForm.tablePaymentRound.date') }}</vs-th>
                      <vs-th class="w-1/4">{{ $t('sections.accounting.dataForm.tablePaymentRound.type') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tablePaymentRound.amount') }}</vs-th>
                      <vs-th class="w-1/12"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(tr, index) in data">
                        <vs-td :data="tr.paymentRoundSeq">
                          {{ tr.paymentRoundSeq }}
                        </vs-td>
                        <vs-td :data="tr.paymentRoundDate">
                          {{ tr.paymentRoundDate }}
                        </vs-td>
                        <vs-td :data="tr.paymentRoundType">
                          <vs-select v-model="tr.paymentRoundType" class="w-full ">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in paymentRoundTypesOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td :data="tr.paymentRoundAmount">
                          <vs-input v-if="['Principle', 'InterestFixed'].includes(tr.paymentRoundType)" type="number"
                                    class="w-full" v-model="tr.paymentRoundAmount"/>
                          <vs-input v-if="!['Principle', 'InterestFixed'].includes(tr.paymentRoundType)" type="number"
                                    class="w-full" value="0" disabled="disabled"/>
                        </vs-td>
                        <vs-td>
                          <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-down" size="small"
                                     @click="copyPaymentRounds(index)"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="flex -mx-2 mb-5">
          <div class="w-1/2 px-2">
            <vx-card title="ข้อมูลเงินกู้" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="loanDetails">
                    <template slot="thead">
                      <vs-th class="w-1/12">{{ $t('sections.accounting.dataForm.tableLoanDetail.no') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.type') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.date') }}</vs-th>
                      <vs-th class="w-1/2">{{ $t('sections.accounting.dataForm.tableLoanDetail.amount') }}</vs-th>
                      <vs-th class="w-1/12"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(tr, index) in data">
                        <vs-td :data="(index+1)">
                          {{ (index + 1) }}
                        </vs-td>
                        <vs-td :data="tr.loanDetailType">
                          <vs-select v-model="tr.loanDetailType" class="w-full ">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in loanDetailTypesOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td :data="tr.loanDate">
                          <flat-pickr :config="config" class="w-full" v-model="tr.loanDate"/>
                        </vs-td>
                        <vs-td :data="tr.amount">
                          <vs-input type="number" class="w-full" v-model="tr.amount"/>
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete"
                                     @click="delLoanDetails(index)"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus-square"
                             @click="addLoanDetails()"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="w-1/2 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.loanPlanInformation')" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="loanDetailPlans">
                    <template slot="thead">
                      <vs-th class="w-1/12">{{ $t('sections.accounting.dataForm.tableLoanDetail.no') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.type') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.date') }}</vs-th>
                      <vs-th class="w-1/2">{{ $t('sections.accounting.dataForm.tableLoanDetail.amount') }}</vs-th>
                      <vs-th class="w-1/12"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(tr, index) in data">
                        <vs-td :data="(index+1)">
                          {{ (index + 1) }}
                        </vs-td>
                        <vs-td :data="tr.loanDetailType">
                          <vs-select v-model="tr.loanDetailType" class="w-full ">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in loanDetailTypesOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td :data="tr.loanDate">
                          <flat-pickr :config="config" class="w-full" v-model="tr.loanDate"/>
                        </vs-td>
                        <vs-td :data="tr.amount">
                          <vs-input type="number" class="w-full" v-model="tr.amount"/>
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete"
                                     @click="delLoanDetailPlans(index)"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus-square"
                             @click="addLoanDetailPlans()"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button class="ml-auto mt-2" @click="submit">{{
                  $t("sections.accounting.dataForm.action.btnSave")
                }}
              </vs-button>
              <vs-button
                class="ml-4 mt-2"
                type="border"
                color="warning"
                @click="reset"
              >{{ $t("sections.accounting.dataForm.action.btnReset") }}
              </vs-button
              >
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>

    <vs-prompt
      @accept="acceptModal"
      @cancel="cancelModal"
      @close="closeModal"
      :active.sync="activeModal.active">
      <div class="vx-col w-full">
        <label class="vs-input--label">ผู้ค้ำประกัน <small class="ml-2"
                                                           v-if="totalSuretyMatched > maxOptions">
          #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalSuretyMatched }} รายการที่พบ
        </small></label>
        <div class="flex">
          <div class="mr-1 flex-1">
            <v-select
              v-model="surety"
              :filterable="false"
              :options="filteredSureties"
              :clearable="true"
              @search="onSearchSurety"
              label="label"
            >
            </v-select>
          </div>
          <div>
            <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-refresh-ccw"
                       @click="onPressedRefreshSuretyOptions()"></vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>

  </div>

</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import {Thai} from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import {ValidationProvider} from 'vee-validate'
import {createNamespacedHelpers, mapGetters} from "vuex";
import THBText from 'thai-baht-text' // for ES6
import {interestRateDefault} from '@/constants/config'
import {IDebtCollectionFeeType, ILoanType, IStatus} from "@/constants/interface";

const moment = require('moment');

const {mapActions: mapCustomerActions, mapState: mapCustomerFields} = createNamespacedHelpers("Customer");
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers("Accounting");
const {mapActions: mapMasterActions, mapState: mapMasterFields} = createNamespacedHelpers("Master");

const isLastDay = function (date) {
  let nowDay = new Date(date.getTime());
  nowDay.setDate(nowDay.getDate() + 1);
  return nowDay.getDate() === 1;
}
export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },

  data() {
    return {
      form: {
        contractDate: "",
        contractNo: "",
        contractIndex: "",
        contractName: "",
        borrower: "",
        contractAmount: 0,
        contractAmountText: "ศูนย์บาทถ้วน",
        project: "",
        campus: "",
        curriculum: "",
        educationStatus: "",
        forecastDate: "",
        graduationDate: "",
        periodStart: "",
        periodTermStart: "",
        periodYearStart: 0,
        periodEnd: "",
        periodTermEnd: "",
        periodYearEnd: 0,
        loan: {
          loanType: "",
          interestType: '',
          interestRate: 0,
          penaltyType: '',
          penaltyRate: 0,
          interestTypeEir: '',
          interestRateEir: 0,
          debtCollectionFeeAmount: interestRateDefault.debtCollectionFeeAmount,
          debtCollectionFeeType: IDebtCollectionFeeType.fixed,
          period: 0,
          paymentDue: new Date(),
          paymentDescription: ""
        }
      },
      suretyDetails: [],
      loanDetails: [],
      loanDetailPlans: [],
      paymentRounds: [],
      activeModal: {
        active: false,
      },
      surety: "",
      config: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
      },
      configPaymentDue: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        disable: [
          function (date) {
            return !(isLastDay(date));
          }
        ]
      },
      filteredBorrowers: [],
      filteredSureties: [],
      totalMatched: 0,
      totalSuretyMatched: 0,
      searchTimeout: null,
      searchSuretyTimeout: null,
      maxOptions: 10,
      debounceTime: 500,
    };
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    const {
      facultyCurriculumOptions,
      projectOptions,
      campusOptions,
      borrowerContractOptions,
      relationshipOptions,
      suretyContractOptions
    } = vm;
    const {
      getSearchCurriculums,
      getSearchProjects,
      getCampusOptions,
      getBorrowerContractOptions,
      getRelationshipOptions,
      getSuretyContractOptions
    } = vm;

    if (facultyCurriculumOptions.length === 0) await getSearchCurriculums();
    if (projectOptions.length === 0) await getSearchProjects();
    if (campusOptions.length === 0) await getCampusOptions();
    if (borrowerContractOptions.length === 0) await getBorrowerContractOptions();
    if (suretyContractOptions.length === 0) await getSuretyContractOptions();
    if (relationshipOptions.length === 0) await getRelationshipOptions();

    await this.onSearchBorrower('');
    await this.onSearchSurety('');

    vm.pms("AccountingContract", "create", "r");
    vm.reset();
    setTimeout(() => {
      vm.$vs.loading.close();
    }, 500);
  },
  computed: {
    ...mapAccountingFields([
      "status",
      "contractNo"
    ]),
    ...mapMasterFields(["curriculums", "projects"]),
    ...mapCustomerFields(["borrowers", "sureties"]),
    ...mapGetters({
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      projectOptions: "Master/projectOptions",
      campusOptions: "Master/campusOptions",
      borrowerContractOptions: "Customer/borrowerContractOptions",
      statusesOptions: "Master/statusesOptions",
      loanTypesOptions: "Master/loanTypesOptions",
      educationStatusesOptions: "Master/educationStatusesOptions",
      paymentRoundTypesOptions: "Master/paymentRoundTypesOptions",
      loanDetailTypesOptions: "Master/loanDetailTypesOptions",
      interestTypesOptions: "Master/interestTypesOptions",
      debtCollectionFeeTypesOptions: "Master/debtCollectionFeeTypesOptions",

      suretyContractOptions: "Customer/suretyContractOptions",
      relationshipOptions: "Master/relationshipOptions",
    }),
    filteredCampusOptions() {
      return this.campusOptions.filter(campus => campus.projectId === this.form.project);
    }
  },
  methods: {
    ...mapAccountingActions([
      "createContract",
      "getContractNo",
    ]),
    ...mapMasterActions([
      "getSearchCurriculums",
      "getSearchProjects",
      'getCampusOptions',
      'getRelationshipOptions'
    ]),
    ...mapCustomerActions([
      "getBorrowerContractOptions",
      "getSuretyContractOptions",
      "getBorrowersCreatedByCurrentUser",
      "getSuretiesCreatedByCurrentUser"
    ]),
    onSearchBorrower(searchText) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.borrowerContractOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalMatched = matched.length;
        this.filteredBorrowers = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    onSearchSurety(searchText) {
      clearTimeout(this.searchSuretyTimeout);

      this.searchSuretyTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.suretyContractOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalSuretyMatched = matched.length;
        this.filteredSureties = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    async submit() {
      const vm = this;
      const {createContract} = vm;
      vm.$refs["form"].validate().then(success => {
        if (!success) {
          alert("กรุณากำหนดข้อมูลให้ครบถ้วน")
          return;
        } else if (vm.loanDetails.length === 0) {
          alert("กรุณากำหนดข้อมูลเงินกู้อย่างน้อย 1 รายการ")
          return;
        } else if (vm.form.loan.period <= 0 || vm.paymentRounds.length === 0) {
          alert("กรุณากำหนดรอบชำระอย่างน้อย 1 รายการ")
          return;
        } else if (vm.suretyDetails.filter(res => res.relationship === '').length >= 1) {
          alert("กรุณากำหนดความสัมพันธ์ของผู้ค้ำประกันให้ครบถ้วน")
          return;
        }
        createContract({
          form: {
            contractDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.contractDate),
            contractIndex: vm.form.contractIndex,
            contractName: vm.form.contractName,
            borrower: {id: vm.form.borrower ? vm.form.borrower.id : ''},
            suretyDetails: vm.suretyDetails.map((res, index) => {
              return {
                surety: {id: res.surety ? res.surety.id : ''},
                seq: (index + 1),
                relationship: {id: res.relationship || ''},
              }
            }),
            contractAmount: parseFloat(vm.form.contractAmount),
            contractAmountText: vm.form.contractAmountText,
            project: {id: vm.form.project || ''},
            campus: {id: vm.form.campus || ''},
            curriculum: {id: vm.form.curriculum || ''},
            educationStatus: vm.form.educationStatus,
            forecastDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.forecastDate),
            graduationDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.graduationDate),
            periodTermStart: vm.form.periodStart.split('/')[0].toString(),
            periodYearStart: parseInt(vm.form.periodStart.split('/')[1]),
            periodTermEnd: vm.form.periodEnd.split('/')[0].toString(),
            periodYearEnd: parseInt(vm.form.periodEnd.split('/')[1]),
            loan: {
              loanType: vm.form.loan.loanType,
              interestType: vm.form.loan.interestType,
              interestRate: parseFloat(String(vm.form.loan.interestRate)),
              penaltyType: vm.form.loan.penaltyType,
              penaltyRate: parseFloat(String(vm.form.loan.penaltyRate)),
              interestRateEir: parseFloat(String(vm.form.loan.interestRateEir)),
              // debtCollectionFeeAmount: "50,100",
              debtCollectionFeeType: vm.form.loan.debtCollectionFeeType,
              period: parseInt(vm.form.loan.period),
              paymentDue: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.loan.paymentDue),
              paymentDescription: vm.form.loan.paymentDescription,
              loanDetails: vm.loanDetails.map(res => {
                return {
                  seq: parseInt(res.seq),
                  loanDetailType: res.loanDetailType,
                  loanDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(res.loanDate),
                  amount: parseFloat(res.amount),
                }
              }),
              loanDetailPlans: vm.loanDetailPlans.map(res => {
                return {
                  seq: parseInt(res.seq),
                  loanDetailType: res.loanDetailType,
                  loanDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(res.loanDate),
                  amount: parseFloat(res.amount),
                }
              }),
              paymentRounds: vm.paymentRounds.map(res => {
                return {
                  ...res,
                  paymentRoundSeq: parseInt(res.paymentRoundSeq),
                  paymentRoundDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(res.paymentRoundDate),
                  paymentRoundAmount: parseFloat(res.paymentRoundAmount)
                }
              })
            }
          },
          vm
        });
      });
    },
    reset() {
      const vm = this;
      let paymentDue = moment().endOf('month').format('DD-MM-YYYY');
      if (moment().date() > 21) {
        paymentDue = moment().add(1, 'month').endOf('month').format('DD-MM-YYYY');
      }
      vm.loanDetails.push({
        seq: vm.loanDetails.length + 1,
        loanDetailType: 'TuitionFee',
        loanDate: moment().format('DD-MM-YYYY'),
        amount: 0
      })
      vm.form = {
        contractDate: moment().format('DD-MM-YYYY'),
        contractNo: vm.contractNo,
        contractIndex: "",
        contractName: "",
        borrower: "",
        suretyDetails: [],
        contractAmount: 0,
        contractAmountText: "ศูนย์บาทถ้วน",
        project: "",
        campus: "",
        curriculum: "",
        educationStatus: "Normal",
        forecastDate: "",
        graduationDate: "",
        periodStart: "",
        periodTermStart: "",
        periodYearStart: 0,
        periodEnd: "",
        periodTermEnd: "",
        periodYearEnd: 0,
        loan: {
          loanType: "",
          interestType: interestRateDefault.interestType,
          interestRate: interestRateDefault.interestRate,
          penaltyType: interestRateDefault.penaltyType,
          penaltyRate: interestRateDefault.penaltyRate,
          interestTypeEir: interestRateDefault.interestType,
          interestRateEir: interestRateDefault.interestRate,
          debtCollectionFeeAmount: interestRateDefault.debtCollectionFeeAmount,
          debtCollectionFeeType: IDebtCollectionFeeType.fixed,
          period: 0,
          paymentDue,
          paymentDescription: ""
        }
      };
    },
    generatePaymentRounds() {
      const vm = this
      let obj = []
      if (vm.form.loan.loanType && parseInt(vm.form.loan.period) >= 1 && vm.form.loan.paymentDue) {
        const period = parseInt(vm.form.loan.period)
        let paymentRoundDate = moment(vm.form.loan.paymentDue, 'DD-MM-YYYY')
        for (let i = 0; i < period; i++) {
          obj.push({
            paymentRoundSeq: i + 1,
            paymentRoundDate: paymentRoundDate.endOf('month').format('DD-MM-YYYY'),
            paymentRoundType: 'None',
            paymentRoundAmount: 0
          })
          paymentRoundDate = paymentRoundDate.add(1, 'M')
        }
      }
      vm.paymentRounds = Object.assign([], obj);
    },
    copyPaymentRounds(index) {
      const vm = this
      let obj = []
      let paymentRoundType, paymentRoundAmount
      obj = vm.paymentRounds.map((res, i) => {
        if (i === index) {
          paymentRoundType = res.paymentRoundType
          paymentRoundAmount = parseFloat(res.paymentRoundAmount)
          return {...res}
        } else if (i > index) {
          return {
            ...res,
            paymentRoundType,
            paymentRoundAmount
          }
        } else {
          return {...res}
        }
      })
      vm.paymentRounds = Object.assign([], obj);
    },
    addLoanDetails() {
      const vm = this
      vm.loanDetails.push({
        seq: vm.loanDetails.length + 1,
        loanDetailType: 'TuitionFee',
        loanDate: moment().format('DD-MM-YYYY'),
        amount: 0
      })
    },
    delLoanDetails(index) {
      const vm = this
      vm.loanDetails.splice(index, 1)
    },
    addLoanDetailPlans() {
      const vm = this
      vm.loanDetailPlans.push({
        seq: vm.loanDetailPlans.length + 1,
        loanDetailType: 'TuitionFee',
        loanDate: moment().format('DD-MM-YYYY'),
        amount: 0
      })
    },
    delLoanDetailPlans(index) {
      const vm = this
      vm.loanDetailPlans.splice(index, 1)
    },
    async setContractNo(borrower) {
      const vm = this
      const {getContractNo} = vm;
      await getContractNo({
        form: {
          borrowerId: borrower.id
        }
      });
      vm.form.contractNo = vm.contractNo
    },
    async addSureties() {
      const vm = this
      vm.activeModal.active = true
    },
    delSureties(index) {
      const vm = this
      vm.suretyDetails.splice(index, 1)
    },
    acceptModal() {
      const vm = this
      const suretyId = vm.surety ? vm.surety.id : null;
      if (vm.suretyDetails.find(res => res.surety.id === suretyId)) {
        alert("คุณได้เลือกผู้ค้ำประกันคนนี้ไปแล้ว")
        return
      }
      if (suretyId === "") {
        alert("กรุณาเลือกผู้ค้ำประกัน")
        return
      }
      vm.suretyDetails.push({
        surety: {id: suretyId},
        relationship: ""
      })
      vm.surety = ""
    },
    cancelModal() {
      const vm = this
      vm.surety = ""
    },
    closeModal() {
      const vm = this
      vm.surety = ""
    },
    suretyName(id) {
      const vm = this
      const surety = vm.sureties.find(res => res.id === id)
      return surety ? surety.fullName : ""
    },
    async onPressedRefreshSuretyOptions() {
      const {getSuretyContractOptions, $vs} = this;
      $vs.loading();
      await getSuretyContractOptions();
      $vs.loading.close();
    }
  },
  watch: {
    "form.borrower": function (selected) {
      const borrowerId = selected ? selected.id : null
      const vm = this
      const borrower = vm.borrowers.find(res => res.id === borrowerId)
      if (borrower) {
        const {fullName, project, campus, curriculum} = borrower
        vm.form.contractName = fullName;
        vm.form.project = project ? project.id : '';
        vm.form.campus = campus ? campus.id : '';
        vm.form.curriculum = curriculum ? curriculum.id : '';
        vm.setContractNo(borrower)
      } else {
        vm.form.contractName = ""
        vm.form.project = ""
        vm.form.campus = ""
        vm.form.curriculum = ""
      }
    },
    "form.curriculum": function (value) {
      const vm = this
      const curriculum = vm.curriculums.find(res => res.id === value)
      if (curriculum) {
        const {curriculumDetails} = curriculum;
        const curriculumDetail = curriculumDetails.find(res => res.status === IStatus.enabled)
        if (curriculumDetail) {
          vm.form.contractAmount = curriculumDetail.maximumLoanAmount
          vm.form.loan.loanType = curriculumDetail.loanType
          vm.form.loan.period = (curriculumDetail.contractPeriod * 12)
        } else {
          vm.form.contractAmount = 0
          vm.form.loan.loanType = ILoanType.principle
          vm.form.loan.period = 0
        }
      } else {
        vm.form.contractAmount = 0
        vm.form.loan.loanType = ILoanType.principle
        vm.form.loan.period = 0
      }
    },
    "form.loan.period": {
      immediate: false,
      handler() {
        this.generatePaymentRounds()
      }
    },
    "form.loan.paymentDue": {
      immediate: false,
      handler() {
        this.generatePaymentRounds()
      }
    },
    "form.contractAmount": {
      immediate: false,
      handler(value) {
        if (value >= 1) {
          this.form.contractAmountText = THBText(value);
        } else {
          this.form.contractAmountText = "ศูนย์บาทถ้วน";
        }
      }
    },
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.vx-coll-fixed-height {
  display: block;
  width: 100%;
  height: 500px;
  overflow: auto;
}

.vx-coll-fixed-height-extra {
  display: block;
  width: 100%;
  height: 425px;
  overflow: auto;
}
</style>
